import React, {Component} from 'react'
import {connect} from 'react-redux'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import CircularProgress from '@mui/material/CircularProgress'
import ToolTip from '@mui/material/Tooltip'
import CheckCircleSharpIcon from '@mui/icons-material/CheckCircleSharp'
import Error from '@mui/icons-material/Error'
import {morphleBaseTheme1} from '../themes'
import {isSuperuser} from "../../../utils/utils";
import {Button} from "@mui/material";
import {Loader} from "../../../utils/const";
import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";

class ImageLoadProgress extends Component {
    constructor(props) {
        super(props);

        this.state = {
            zoomLevel: 0,
            avgTimeZoom: 0,
            avgTime: 0,
            avgRenderTimeZoom: 0,
            avgRenderTimeDrag: 0,
            isScrolling: false,
            iterationData: [],
        }

        this.isAnalyticsOn = isSuperuser();
        this.renderTimeDrag = 0;
        this.renderTimeZoom = 0;

        this.elapsedTimeZoom = 0;
        this.dragCountsZoom = 0;

        this.elapsedTime = 0;
        this.dragCounts = 0;
    }

    componentDidMount() {
        window.addEventListener('wheel', this.handleWheel);
        window.addEventListener('mousedown', this.handleMouseDown);

    }

    componentWillUnmount() {
        window.removeEventListener('wheel', this.handleWheel);
        window.removeEventListener('mousedown', this.handleMouseDown);

    }

    handleWheel = (event) => {
        if (event.deltaY !== 0) {
            this.setState({isScrolling: true});
        } else {
            this.setState({isScrolling: false});
        }
    };

    handleMouseDown = () => {
        this.setState({isScrolling: false});
    };


    componentDidUpdate(prevProps, prevState) {

        if (prevProps.z === this.props.z) {
            if (prevProps.progress === 0 && this.props.progress > 0) {
                if (this.state.isScrolling) {
                    this.startTimeZoom = new Date().getTime();
                } else {
                    this.startTime = new Date().getTime();
                }
            }
            if (prevProps.progress < 101 && this.props.progress === 101) {
                if (this.state.isScrolling) {
                    this.endTimeZoom = new Date().getTime();
                    let diff = this.endTimeZoom - this.startTimeZoom;
                    let renderTime = this.endTimeZoom - this.props.lastImageRenderTime
                    if (diff !== 0) {
                        this.elapsedTimeZoom += diff;
                        this.dragCountsZoom++;
                        this.setState({avgTimeZoom: (this.elapsedTimeZoom / this.dragCountsZoom).toFixed(2)})
                        if (this.isAnalyticsOn) {
                            this.renderTimeZoom += renderTime
                            this.setState((prevState) => ({
                                avgRenderTimeZoom: (this.renderTimeZoom / this.dragCountsZoom).toFixed(2),
                                iterationData: [
                                    ...prevState.iterationData,
                                    {
                                        iteration: this.dragCountsZoom,
                                        currentIterationTime: diff.toFixed(2),
                                        currentIterationRenderTime: renderTime.toFixed(2),
                                        event: 'zoom',
                                    },
                                ],
                            }));
                        }
                    }
                } else {
                    this.endTime = new Date().getTime();
                    let diff = this.endTime - this.startTime;
                    let renderTime = this.endTime - this.props.lastImageRenderTime
                    if (diff !== 0) {
                        this.elapsedTime += diff;
                        this.dragCounts++;
                        this.setState({avgTime: (this.elapsedTime / this.dragCounts).toFixed(2)})
                        if (this.isAnalyticsOn) {
                            this.renderTimeDrag += renderTime
                            this.setState((prevState) => ({
                                avgRenderTimeDrag: (this.renderTimeDrag / this.dragCounts).toFixed(2),
                                iterationData: [
                                    ...prevState.iterationData,
                                    {
                                        iteration: this.dragCounts,
                                        currentIterationTime: diff.toFixed(2),
                                        currentIterationRenderTime: renderTime.toFixed(2),
                                        event: 'drag',
                                    },
                                ],
                            }));
                        }
                    }
                }
            }
        }
    }

    downloadDataCsv = (event) => {
        const {iterationData} = this.state;
        const csvContent = "Event,Iteration,CurrentIterationTime,CurrentRenderTime\n" +
            iterationData.filter((iteration) => event === '' || iteration.event === event)
                .map((iteration) => `${iteration.event},${iteration.iteration},${iteration.currentIterationTime},${iteration.currentIterationRenderTime}`).join("\n") +
            `\n\nAvg Time (Drag),${this.state.avgTime}, avg Render Time (Drag), ${this.state.avgRenderTimeDrag},Total Count,${this.dragCounts}` +
            `\nAvg Time (Zoom),${this.state.avgTimeZoom}, avg Render Time (Zoom), ${this.state.avgRenderTimeZoom},Total Count,${this.dragCountsZoom}`;

        const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `iteration_data_${performance.now().toFixed(2)}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    renderIcon = (progress, isLoading) => {
        if (isLoading) {
            return <LoadingOutlined style={{color: "#00f548", fontSize: "20px"}}/>
        }
        if (progress < 100) {
            return (
                <ToolTip title={`Loading Image ${progress.toFixed(1)}%`}>
                    <div>
                        <CircularProgressFilled
                            variant="determinate"
                            color="inherit"
                            thickness={6}
                            value={progress}/>
                    </div>
                </ToolTip>
            )
        }

        if (progress === 100)
            return (
                <ToolTip title={`Rendering Image`}>
                    <div>
                        <Box sx={{transform: 'scale(0.5)'}}>
                            <CircularProgress
                                color={'inherit'}
                                thickness={6}/>
                        </Box>
                    </div>
                </ToolTip>
            )

        if (progress > 100) {
            let title = 'Image has been successfully loaded';
            title = (<>
                {title}<br/>
                Avg Time Drag: {this.state.avgTime} millisec in {this.dragCounts} iterations<br/>
                Avg time Zoom: {this.state.avgTimeZoom} millisec in {this.dragCountsZoom} iterations<br/>
                {this.isAnalyticsOn ? <>
                    Avg Render Zoom time: {this.state.avgRenderTimeZoom} millisec
                    in {this.dragCountsZoom} iterations<br/>
                    Avg Render Drag time: {this.state.avgRenderTimeDrag} millisec in {this.dragCounts} iterations<br/>
                    <Button color={'secondary'}
                            sx={{fontSize: 10, border: '1px solid #00f548', color: '#00f548', m: 0.5, p: 0}}
                            onClick={() => this.downloadDataCsv('')}>Download</Button>
                    <Button color={'secondary'}
                            sx={{fontSize: 10, border: '1px solid #00f548', color: '#00f548', m: 0.5, p: 0}}
                            onClick={() => this.downloadDataCsv('drag')}>Drag</Button>
                    <Button color={'secondary'}
                            sx={{fontSize: 10, border: '1px solid #00f548', color: '#00f548', m: 0.5, p: 0}}
                            onClick={() => this.downloadDataCsv('zoom')}>Zoom</Button>
                </> : null}
            </>)
            return (
                <ToolTip title={title}>
                    <CheckCircleSharpIcon
                        sx={{
                            color: morphleBaseTheme1.palette.headBarIcon.secondary
                        }}/>
                </ToolTip>
            )
        }

        return (
            <ToolTip title={'Error in loading Image'}>
                <Error/>
            </ToolTip>
        )
    }

    render() {
        if (this.props.isOpenSeadragon) return null;
        return (
            <Stack
                className='ImageLoadProgress ImageLoadProgress-forTour'
                alignItems={'center'}
                justifyContent={'center'}
                width={'4vh'}
                height={'4vh'}
                sx={{color: morphleBaseTheme1.palette.headBarIcon.primary}}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {this.renderIcon(this.props.progress, this.props.loadingState.loading)}
                </Box>
            </Stack>
        )
    }
}

const mapStateToProps = (state) => {
    let loadingState = state.slideLoadingReducer;
    let {activeMapId} = state.gammaStateReducer;
    let {slidemap, z} = state.mapsStateReducer[activeMapId];
    return {
        slidemap, z,
        isOpenSeadragon: slidemap?._isOpenSeadragon === true,
        progress: state.gammaStateReducer.imageLoadProgress,
        lastImageRenderTime: state.gammaStateReducer.lastImageRenderTime,
        loadingState
    }
}

export default connect(mapStateToProps)(ImageLoadProgress)

const CircularProgressFilled = (props) => (
    <Box
        sx={{
            position: 'relative',
            transform: 'scale(0.5)'
        }}>
        <CircularProgress
            variant="determinate"
            {...props}
            value={100}
            sx={{
                color: morphleBaseTheme1.palette.headBarIcon.primary,
                opacity: 0.6
            }}
        />
        <CircularProgress
            variant="determinate"
            {...props}
            sx={{
                position: 'absolute',
                left: 0
            }}
        />
    </Box>
)

